import React, { Component } from 'react';
import { getLocaleDateTimeString } from '../utils.jsx';
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import IconButtonMenu from './Redesing/icon-button-menu';
import CardView from './Redesing/card-view';
import Typography from '@mui/material/Typography';
import { TextField, Chip } from '@mui/material';
import { Stack } from '@mui/system';
import Box from '@mui/material/Box';

function MessageRow(props) {
  const message = props.message;

  // Handle Slack early end review entries
  if (message?.source === 'slack_early_end_review') {
    return (
      <Box
        className="messageRow"
        sx={{
          borderLeft: message.is_safety_issue ? '3px solid #ed6c02' : '3px solid #1976d2',
          pl: 1,
        }}
      >
        <Box className="flexDisplay flexWrap" sx={{ alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" className="topRow">
            Slack Review
          </Typography>
          <Chip label={message.action} size="small" color="primary" />
          {message.is_safety_issue && (
            <Chip
              icon={<WarningAmberIcon />}
              label="Safety Issue"
              size="small"
              color="warning"
            />
          )}
          <Typography variant="body2" className="lightText topRow">
            {getLocaleDateTimeString(message.created_on)}
          </Typography>
        </Box>
        {message.safety_reason && (
          <Typography variant="body2" className="messageContent" align={'justify'}>
            <strong>Safety Concern:</strong> {message.safety_reason}
          </Typography>
        )}
        {message.original_tags?.length > 0 && (
          <Typography variant="body2" className="lightText">
            Tags: {message.original_tags.join(', ')}
          </Typography>
        )}
      </Box>
    );
  }

  // Default: regular admin/user note
  return (
    <Box className="messageRow">
      <Box className="flexDisplay flexWrap">
        <Typography variant="subtitle1" className="topRow">
          {message?.user_id || message?.admin_id}
        </Typography>
        <Typography variant="body2" className="lightText topRow">
          {getLocaleDateTimeString(message?.created_on)}
        </Typography>
        <Typography variant="body2" className="lightText">
          {message?.type === 'internal' ? '(Internal)' : ''}
        </Typography>
      </Box>
      <Typography variant="body2" className="messageContent" align={'justify'}>
        {message?.message?.toString()}
      </Typography>
    </Box>
  );
}

export default class CommunicationLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start: 0,
      end: 10,
    };

    this.content = this.content.bind(this);
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
  }

  next() {
    this.setState((state) => ({
      start: state.start + 10,
      end: state.end + 10,
    }));
  }

  prev() {
    this.setState((state) => ({
      start: state.start - 10,
      end: state.end - 10,
    }));
  }

  getButtons = () => {
    const cant = this.props.buttons || 1;
    const buttons = [];
    if (cant === 1) {
      buttons.push({
        label: this.props.saveButtonText || 'Save Note',
        onClick: this.props.saveNote,
        disabled: !this.props.note,
        startIcon: <SaveIcon />,
        dataId: 'communication-log-save-note',
      });
    } else {
      buttons.push({
        label: this.props.saveButtonText || 'Save Note',
        onClick: this.props.saveNote,
        disabled: !this.props.note,
        startIcon:
          this.props.saveButtonText === 'Send to User' ? <SendIcon /> : <SaveIcon />,
        dataId: 'communication-log-save-note',
      });
      buttons.push({
        label: this.props.secondarySaveButtonText || 'Save Internal Note',
        onClick: this.props.secondarySaveNote,
        disabled: !this.props.note,
        startIcon: <SaveIcon />,
        dataId: 'communication-log-save-internal-note',
      });
    }
    return buttons;
  };

  content() {
    const { start, end } = this.state;
    let { log } = this.props;

    if (typeof log === 'string') {
      log = JSON.parse(log);
    }

    return (
      <div data-id="communication-log-container">
        {this.props.ticketDescription}
        {!log?.length ? (
          <Typography variant={'subtitle2'} paddingLeft={2} paddingTop={2}>
            {this.props.noNoteText || 'No notes added for this ticket'}
          </Typography>
        ) : (
          log
            .slice(start, end)
            .map((message, index) => (
              <MessageRow message={message} key={`message-${index}`} />
            ))
        )}

        <Stack px={2} py={2} spacing={2}>
          <TextField
            maxRows={10}
            minRows={2}
            multiline
            variant="outlined"
            fullWidth
            value={this.props.note}
            onChange={this.props.handleNoteChange}
            data-id="communication-log-note"
            placeholder={this.props.placeholder || 'Add note'}
          />

          <div className="flexDisplay justifyBetween">
            <IconButtonMenu buttons={this.getButtons()} />
            <IconButtonMenu
              buttons={[
                {
                  label: 'Prev',
                  onClick: this.prev,
                  disabled: !log || start === 0 || log.length <= 10,
                },
                {
                  label: 'Next',
                  onClick: this.next,
                  disabled: !log || end >= log.length || log.length <= 10,
                },
              ]}
            />
          </div>
        </Stack>
      </div>
    );
  }

  render() {
    return (
      <CardView
        isLoading={!this.props.loaded}
        content={this.content()}
        title={this.props.header || 'Communication Log'}
      />
    );
  }
}
